var React = require('react');

function Profile (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"36","height":"36","key":0}),React.createElement("path",{"stroke":"#FFFFFF","strokeLinecap":"round","strokeLinejoin":"round","d":"M23 10C23 7.23875 20.76125 5 18 5 15.23875 5 13 7.23875 13 10 13 12.76125 15.23875 15 18 15 20.76125 15 23 12.76125 23 10zM31 31C31 24.004 25.1801053 19 18 19 10.8198947 19 5 24.004 5 31L31 31z","key":1})]));
}

Profile.displayName = "Profile";

Profile.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36"};

module.exports = Profile;

Profile.default = Profile;



//////////////////
// WEBPACK FOOTER
// ./src/app/icons/profile.svg
// module id = 710
// module chunks = 0